import { render } from "./DefaultItemInformation.vue?vue&type=template&id=1bd0847a"
import script from "./DefaultItemInformation.vue?vue&type=script&lang=js"
export * from "./DefaultItemInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__